import React, { FunctionComponent } from "react";
import { IDetailPreviewCard } from "@/src/@types/blog";
import Container from "@/src/components/atoms/Container/Container";
import SwipeMessage from "@/src/components/organisms/CompareChart/Swipe";
import SliderPreviewCard from "../../atoms/SliderPreviewCard";

export interface BlogLandingHeroProps {
    featuredBlogCards: IDetailPreviewCard[];
}

const BlogLandingHero: FunctionComponent<BlogLandingHeroProps> = props => {
    const goTo = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        event.preventDefault();
        const btn = event.currentTarget;

        //Equivalent
        //const carousel = document.querySelector('.carousel')
        //const carousel = document.querySelector('#carouselId')
        const carousel = btn.parentElement!.parentElement!.parentElement!;

        const href = btn.getAttribute("href")!;
        const target = carousel.querySelector<HTMLDivElement>(href)!;
        const left = target.offsetLeft;
        carousel.scrollTo({ left: left });
    };

    return (
        <section className="BlogLandingHero bg-accent-secondary-background pb-12 pt-8 text-text-primary shadow-lg">
            <Container>
                <h1 className="BlogLandingHero-headline mb-1 text-center text-lg tracking-lg text-text-primary">BlogBowl for Dogs & Cats</h1>
                <p className="BlogLandingHero-subheadline mb-8 text-center text-subheadline1  tracking-subheadline1">
                    Get helpful tips in our blog for dogs, puppies, cats, and kittens.
                </p>
                <div className="CardCarousel-wrapper">
                    <h2 className="CardCarousel-headline mb-4 text-center text-overline uppercase tracking-overline text-accent-secondary-medium">Featured Posts</h2>
                    <SwipeMessage bgColorClass="text-text-primary mb-4 md:hidden" title={"Swipe"} />
                    <div className="relative mx-auto max-w-[1024px]">
                        <div className="carousel pb-4">
                            {props.featuredBlogCards.map((card, index) => (
                                <div id={`item${index + 1}`} key={card.title} className={`carousel-item w-fit p-2`}>
                                    <div className="relative -left-2 hidden items-center md:flex">
                                        <a
                                            onClick={goTo}
                                            href={`#item${index === 0 ? props.featuredBlogCards.length : index}`}
                                            className="relative flex h-[32px] w-[32px] items-center justify-center rounded-md border border-border-light bg-background-surface py-1 px-2 text-caption font-bold tracking-caption text-text-primary"
                                        >
                                            ❮
                                        </a>
                                    </div>
                                    <SliderPreviewCard content={card} />
                                    <div className="relative -right-2 hidden items-center md:flex">
                                        <a
                                            onClick={goTo}
                                            href={`#item${index + 1 === props.featuredBlogCards.length ? 1 : index + 2}`}
                                            className="relative flex h-[32px] w-[32px] items-center justify-center rounded-md border border-border-light bg-background-surface py-1 px-2 text-caption font-bold tracking-caption text-text-primary"
                                        >
                                            ❯
                                        </a>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </Container>
        </section>
    );
};

export default BlogLandingHero;
